/**
 * Where the SPA sends its API calls.
 *
 * This app is served from more than one hostname — teknik.sh and, since Luna's
 * dashboard moved to its own domain, lunako.app. The API lives on whichever
 * origin served the page, so the answer is almost always `window.location.origin`.
 *
 * It is worth being explicit about why the build-time `VITE_API_URL` is no longer
 * consulted first in the browser. It is baked to `https://teknik.sh` at build
 * time, so honouring it on lunako.app would send every request cross-origin to
 * teknik.sh — where the lunako.app session cookie does not exist. The symptom is
 * not a network error but a silent, total logout: the page loads, every call
 * comes back unauthenticated, and the dashboard renders as "no servers available".
 *
 * `VITE_API_URL` still applies during local development, where the dev server and
 * the API genuinely are different origins.
 */
export function resolveApiBase(): string {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    const isLocal = host === 'localhost' || host === '127.0.0.1' || host === '[::1]';
    if (!isLocal) return window.location.origin;
  }
  return (import.meta as any).env?.VITE_API_URL || 'http://localhost:3000';
}
